export const fileToUri = (file: any) => {
  return new Promise((resolve) => {
      const reader = new window.FileReader();
      const blobFile = new Blob([file], { type: "image/png" });
      reader.readAsDataURL(blobFile);
      reader.onload = function () {
          const imageDataUrl = reader.result;
          resolve(imageDataUrl);
      };
  });
};
